import { CircularProgress } from "@material-ui/core";
import { Text } from "components/Typography/text.styled";
import { BannerComponent } from "components/banners/banner.component";
import {
  LoggedInPageContainer,
  LoggedOutPageContainer,
} from "components/pageLayouts/pageLayouts.styled";
import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import { useTranslation } from "react-i18next";
import { Page } from "web-apps/company/components/schedule/components/views/shared/schedule.styled";
import { Schedule } from "web-apps/company/components/schedule/schedule.component";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import styled from "styled-components";

export const SchedulePage = () => {
  const [companyState] = useCompanyStore();
  const [authState] = useCompanyStore();
  const { t } = useTranslation();
  return (
    <Page>
      <SchedulePageContainer>
        {authState.isLoading || companyState.isLoading ? (
          <LoggedOutPageContainer>
            <CircularProgress />
          </LoggedOutPageContainer>
        ) : (
          <SchedulePageContainer>
            {companyState.company?.verified ? (
              <>
                <Schedule />
              </>
            ) : (
              <BannerComponent
                icon="clock"
                backgroundColor={Color.ChampagnePink}
                fill={Color.Destructive}
              >
                <Text
                  fontSize={FontSize.Large}
                  fontFamily={FontFamily.MontserratSemiBold}
                  color={Color.Destructive}
                >
                  {t("GigsCompany.UnverifiedAccount")}
                </Text>
                <Text>{t("GigsCompany.UnverifiedAccountDetails")}</Text>
              </BannerComponent>
            )}
          </SchedulePageContainer>
        )}
      </SchedulePageContainer>
    </Page>
  );
};

const SchedulePageContainer = styled(LoggedInPageContainer)`
  margin-top: 0;
`;
